import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=ce15386c&scoped=true&"
var script = {}
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=ce15386c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce15386c",
  null
  
)

export default component.exports